import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IDefaultNotification, NotificationType } from '@settings/models';
import { Endpoint } from '@app/constants/endpoints.constants';

@Injectable({
  providedIn: 'root'
})
export class DefaultNotificationsRepoService {
  constructor(private _httpClient: HttpClient) {}

  getDefaultNotifications(): Observable<IDefaultNotification[]> {
    return this._httpClient.get<IDefaultNotification[]>(Endpoint.DefaultNotifications);
  }

  patchDefaultNotifications(
    defaultNotifications: IDefaultNotification[],
    types: NotificationType[]
  ): Observable<undefined> {
    let url: string = Endpoint.DefaultNotifications;

    if (types.length === 1) {
      url += `?type=${types[0]}`;
    }

    return this._httpClient.patch<undefined>(url, defaultNotifications);
  }
}
